/**
 * Deterministic colour for a league, used as a fallback avatar when a league has
 * no uploaded image. Same league id always maps to the same colour so leagues
 * stay visually distinguishable in lists/dropdowns. Uses the golden-angle
 * increment for a well-spread hue distribution.
 */
export const getLeagueColor = (id: number): string => {
  const hue = Math.round((id * 137.508) % 360)
  return `hsl(${hue}, 65%, 55%)`
}
